import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';

import {AppDispatch} from '~/redux/root-store';
import {useNotification} from '~/hooks';
import {RootState} from '~/redux/root-reducer';
import NotFoundPage from '~/pages/not-found';
import {APPLICATIONS_FORMS_TYPES} from '~/constants/applications-forms';
import StudentForm from './StudentForm';
import AmbassadorForm from './AmbassadorForm';
import {Col} from '~/components/elements';
import {trackPageViewGA} from '~/services/google-analytics';
const queryString = require('query-string');

interface ApplicationsFormsRouteParams {
  type: string;
}

const ApplicationsForms = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);

  const location = window.location;
  const query: ApplicationsFormsRouteParams = queryString.parse(location.search);

  useEffect(() => {
    if (query.type === APPLICATIONS_FORMS_TYPES.STUDENT || query.type === APPLICATIONS_FORMS_TYPES.AMBASSADOR) {
      trackPageViewGA(`/applications-forms/${query.type}`, `MDQ-Applications Forms - ${query.type}`);
    }
  }, [query.type]);

  const renderApplicationsForms = () => {
    switch (query.type) {
      case APPLICATIONS_FORMS_TYPES.STUDENT:
        return <StudentForm />;
      case APPLICATIONS_FORMS_TYPES.AMBASSADOR:
        return <AmbassadorForm />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <NotFoundPage />;
    }
  };

  return (
    <Col bg="white" flexGrow={1}>
      {renderApplicationsForms()}
    </Col>
  );
};

export default ApplicationsForms;
